import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e05c77a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag cursor-move" }, "⋮⋮", -1))
const _hoisted_3 = { class: "border-t mt-5 pt-3" }
const _hoisted_4 = { class: "NewTable__thead" }
const _hoisted_5 = { class: "thead__tr" }
const _hoisted_6 = {
  key: 0,
  class: "thead__th text-left"
}
const _hoisted_7 = {
  key: 1,
  class: "thead__th text-left"
}
const _hoisted_8 = {
  key: 0,
  class: "hint"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  scope: "col",
  class: "thead__th text-left"
}
const _hoisted_11 = { class: "NewTable__tbody" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "tbody__td"
}
const _hoisted_14 = {
  key: 1,
  class: "tbody__td"
}
const _hoisted_15 = {
  key: 0,
  class: "hint"
}
const _hoisted_16 = {
  key: 1,
  class: "hint"
}
const _hoisted_17 = {
  key: 2,
  class: "tbody__td w-40"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "tbody__tr tbody__overall"
}
const _hoisted_21 = {
  key: 0,
  class: "tbody__tr tbody__overall"
}
const _hoisted_22 = { class: "NewTable__thead" }
const _hoisted_23 = { class: "thead__tr" }
const _hoisted_24 = {
  key: 0,
  class: "thead__th text-left"
}
const _hoisted_25 = {
  key: 1,
  class: "thead__th text-left"
}
const _hoisted_26 = {
  key: 0,
  class: "hint"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 2,
  scope: "col",
  class: "thead__th text-left"
}
const _hoisted_29 = { class: "NewTable__tbody" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "tbody__td"
}
const _hoisted_32 = {
  key: 1,
  class: "tbody__td"
}
const _hoisted_33 = {
  key: 0,
  class: "hint"
}
const _hoisted_34 = {
  key: 1,
  class: "hint"
}
const _hoisted_35 = {
  key: 2,
  class: "tbody__td w-40"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "tbody__tr tbody__overall"
}
const _hoisted_39 = {
  key: 0,
  class: "tbody__tr tbody__overall"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.tablesStore.isOpen)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Выберите колонки для отображения",
          onCancel: _ctx.tablesStore.toggleModal,
          onSubmit: _ctx.setColumns
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              class: "grid grid-cols-2 gap-3",
              list: _ctx.state.columns,
              handle: ".drag",
              "item-key": "id",
              tag: "transition-group",
              "component-data": {
                tag: 'div',
                type: 'transition-group',
                name: !_ctx.state.drag ? 'flip-list' : null,
            },
              animation: 200,
              onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.drag = true)),
              onEnd: _ctx.onDragEnd
            }, {
              item: _withCtx(({ element, index }) => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  (_openBlock(), _createBlock(_component_new_checkbox, {
                    class: "checkbox--blue",
                    key: `checkbox-${index}`,
                    value: _ctx.state.columns[index].isChecked,
                    "onUpdate:value": ($event: any) => ((_ctx.state.columns[index].isChecked) = $event),
                    label: element.name
                  }, null, 8, ["value", "onUpdate:value", "label"]))
                ])
              ]),
              _: 1
            }, 8, ["list", "component-data", "onEnd"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_new_checkbox, {
                class: "checkbox--blue",
                value: _ctx.isAllColumnsChecked,
                label: "Выбрать все",
                "onUpdate:value": _ctx.onAllColumnsSelect
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]),
          _: 1
        }, 8, ["onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.fixed && _ctx.table && _ctx.table.offsetWidth)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["NewTableHolder", _ctx.getTableHolderClass]),
          style: _normalizeStyle(`padding-bottom: ${_ctx.paddingBottom}px`),
          onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScrollThead && _ctx.onScrollThead(...args))),
          ref: "thead"
        }, [
          _createElementVNode("table", {
            class: "NewTable",
            border: "1",
            cellpadding: "0",
            cellspacing: "0",
            style: _normalizeStyle(`width: ${_ctx.state.fake_width}px`)
          }, [
            _createElementVNode("thead", _hoisted_4, [
              _createElementVNode("tr", _hoisted_5, [
                (_ctx.hasCheckboxColumn)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, [
                      _createVNode(_component_new_checkbox, {
                        class: "checkbox--table",
                        value: _ctx.state.is_all_checked,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.is_all_checked) = $event)),
                        disabled: !_ctx.rows.length,
                        onChange: _ctx.onSelectAll
                      }, null, 8, ["value", "disabled", "onChange"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hasIndexColumn)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, "№"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, i) => {
                  return (_openBlock(), _createElementBlock("th", {
                    scope: "col",
                    class: _normalizeClass([
                            'thead__th text-left',
                            {
                                'th-flex': column.filter,
                                'text-center': column.isCentered,
                            },
                        ]),
                    key: `TableRow-${i}`
                  }, [
                    _createTextVNode(_toDisplayString(column.name) + " ", 1),
                    (column.hintText)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(column.hintText), 1))
                      : _createCommentVNode("", true),
                    (column.filter)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.onFilterClick(column.filter)),
                          class: _normalizeClass([
                                'fas fa-caret-down ml-2 cursor-pointer',
                                { 'rotate-180': column.filterApplied },
                            ])
                        }, null, 10, _hoisted_9))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                (_ctx.$slots.actions)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `TableRow-${i}`,
                  class: _normalizeClass(["tbody__tr", {
                        'clickable-row': _ctx.clickableRows,
                        [_ctx.selectClass]: _ctx.selectIndexes.includes(i),
                        redTr: row.isRed,
                        greenTr: row.isGreen,
                    }]),
                  onClick: ($event: any) => (_ctx.onRowClick(row))
                }, [
                  (_ctx.hasCheckboxColumn)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                        _createVNode(_component_new_checkbox, {
                          class: "checkbox--blue",
                          value: _ctx.isRowSelected(row),
                          onChange: ($event: any) => (_ctx.onSelectRow(row))
                        }, null, 8, ["value", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$slots['table-index'])
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(i + 1), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: `TableTd-${i}-${j}`,
                      class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                    }, [
                      (_ctx.$slots.td)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _renderSlot(_ctx.$slots, "td", {
                              row: row,
                              index: i,
                              column: column,
                              key: `${i}-${j}`
                            }, undefined, true),
                            (column.withHint && row[column.key])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(row[column.key]), 1))
                              : (column.customHint && row[column.key])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row[column.key][column.customHint]), 1))
                                : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(row[column.key]), 1)
                          ], 64))
                    ], 2))
                  }), 128)),
                  (_ctx.$slots.actions)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                        _renderSlot(_ctx.$slots, "actions", { row: row }, undefined, true)
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_12))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nestedRows, (nestedrow, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `TableNestedRow-${i}`
                }, [
                  _createElementVNode("tr", {
                    class: _normalizeClass(["tbody__tr", {
                            'clickable-row': _ctx.clickableRows,
                            expander: _ctx.isNestedRowExpanded(nestedrow),
                        }]),
                    onClick: ($event: any) => (_ctx.onParentRowClick(nestedrow))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: `TableTd-${i}-${j}`,
                        class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                      }, [
                        (_ctx.$slots.td)
                          ? _renderSlot(_ctx.$slots, "td", {
                              row: nestedrow,
                              index: i,
                              column: column,
                              key: `${i}-${j}`
                            }, undefined, true)
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(nestedrow[column.key]), 1)
                            ], 64))
                      ], 2))
                    }), 128))
                  ], 10, _hoisted_18),
                  (_ctx.nestedRowsExpandKey && nestedrow[_ctx.nestedRowsExpandKey])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nestedrow[_ctx.nestedRowsExpandKey], (nestedrow_data, j) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `NestedRowData-${j}`,
                            class: _normalizeClass(["expanded", {
                                hidden: !_ctx.isNestedRowExpanded(nestedrow),
                                last: j === nestedrow[_ctx.nestedRowsExpandKey].length - 1,
                                'bg-yellow-100': nestedrow_data.isYellow,
                            }]),
                            onClick: ($event: any) => (_ctx.onRowClick(nestedrow_data))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: `TableTd-${i}-${j}`,
                                class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                              }, [
                                (_ctx.$slots.td)
                                  ? _renderSlot(_ctx.$slots, "td", {
                                      row: nestedrow_data,
                                      index: i,
                                      column: column,
                                      key: `${i}-${j}`
                                    }, undefined, true)
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(nestedrow[column.key]), 1)
                                    ], 64))
                              ], 2))
                            }), 128))
                          ], 10, _hoisted_19))
                        }), 128)),
                        (_ctx.$slots.overallNested)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: `TableOverallTd-${j}`,
                                  class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                                }, [
                                  _renderSlot(_ctx.$slots, "overallNested", {
                                    column: column,
                                    row: nestedrow
                                  }, undefined, true)
                                ], 2))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (_ctx.$slots.overall)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: `TableOverallTd-${j}`,
                        class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                      }, [
                        _renderSlot(_ctx.$slots, "overall", { column: column }, undefined, true)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4)
        ], 38))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["NewTableHolder", _ctx.getTableHolderClass]),
      style: _normalizeStyle(`padding-bottom: ${_ctx.paddingBottom}px`),
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScrollTbody && _ctx.onScrollTbody(...args))),
      ref: "table"
    }, [
      _createElementVNode("table", {
        class: _normalizeClass(["NewTable", { 'NewTable--small': _ctx.small }]),
        border: "1",
        cellpadding: "0",
        cellspacing: "0",
        ref: "tbody"
      }, [
        _createElementVNode("thead", _hoisted_22, [
          _createElementVNode("tr", _hoisted_23, [
            (_ctx.hasCheckboxColumn)
              ? (_openBlock(), _createElementBlock("th", _hoisted_24, [
                  _createVNode(_component_new_checkbox, {
                    class: "checkbox--table",
                    value: _ctx.state.is_all_checked,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.is_all_checked) = $event)),
                    disabled: !_ctx.rows.length,
                    onChange: _ctx.onSelectAll
                  }, null, 8, ["value", "disabled", "onChange"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasIndexColumn)
              ? (_openBlock(), _createElementBlock("th", _hoisted_25, "№"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, i) => {
              return (_openBlock(), _createElementBlock("th", {
                scope: "col",
                class: _normalizeClass([
                            'thead__th text-left',
                            {
                                'th-flex': column.filter,
                                'text-center': column.isCentered,
                            },
                        ]),
                key: `TableRow-${i}`
              }, [
                _createTextVNode(_toDisplayString(column.name) + " ", 1),
                (column.hintText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(column.hintText), 1))
                  : _createCommentVNode("", true),
                (column.filter)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.onFilterClick(column.filter)),
                      class: _normalizeClass([
                                'fas fa-caret-down ml-2 cursor-pointer',
                                { 'rotate-180': column.filterApplied },
                            ])
                    }, null, 10, _hoisted_27))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (_ctx.$slots.actions)
              ? (_openBlock(), _createElementBlock("th", _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `TableRow-${i}`,
              class: _normalizeClass(["tbody__tr", {
                        'clickable-row': _ctx.clickableRows,
                        [_ctx.selectClass]: _ctx.selectIndexes.includes(i),
                        redTr: row.isRed,
                        greenTr: row.isGreen,
                    }]),
              onClick: ($event: any) => (_ctx.onRowClick(row))
            }, [
              (_ctx.hasCheckboxColumn)
                ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                    (_ctx.$slots['td-checkbox'])
                      ? _renderSlot(_ctx.$slots, "td-checkbox", {
                          key: 0,
                          value: _ctx.isRowSelected(row),
                          row: row
                        }, undefined, true)
                      : (_openBlock(), _createBlock(_component_new_checkbox, {
                          key: 1,
                          class: "checkbox--blue",
                          value: _ctx.isRowSelected(row),
                          onChange: ($event: any) => (_ctx.onSelectRow(row))
                        }, null, 8, ["value", "onChange"]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$slots['table-index'])
                ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(i + 1), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `TableTd-${i}-${j}`,
                  class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                }, [
                  (_ctx.$slots.td)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _renderSlot(_ctx.$slots, "td", {
                          row: row,
                          index: i,
                          column: column,
                          key: `${i}-${j}`
                        }, undefined, true),
                        (column.withHint && row[column.key])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(row[column.key]), 1))
                          : (column.customHint && row[column.key])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(row[column.key][column.customHint]), 1))
                            : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row[column.key]), 1)
                      ], 64))
                ], 2))
              }), 128)),
              (_ctx.$slots.actions)
                ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                    _renderSlot(_ctx.$slots, "actions", { row: row }, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_30))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nestedRows, (nestedrow, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `TableNestedRow-${i}`
            }, [
              _createElementVNode("tr", {
                class: _normalizeClass(["tbody__tr", {
                            'clickable-row': _ctx.clickableRows,
                            expander: _ctx.isNestedRowExpanded(nestedrow),
                        }]),
                onClick: ($event: any) => (_ctx.onParentRowClick(nestedrow))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: `TableTd-${i}-${j}`,
                    class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                  }, [
                    (_ctx.$slots.td)
                      ? _renderSlot(_ctx.$slots, "td", {
                          row: nestedrow,
                          index: i,
                          column: column,
                          key: `${i}-${j}`
                        }, undefined, true)
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(nestedrow[column.key]), 1)
                        ], 64))
                  ], 2))
                }), 128))
              ], 10, _hoisted_36),
              (_ctx.nestedRowsExpandKey && nestedrow[_ctx.nestedRowsExpandKey])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nestedrow[_ctx.nestedRowsExpandKey], (nestedrow_data, j) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `NestedRowData-${j}`,
                        class: _normalizeClass(["expanded", {
                                hidden: !_ctx.isNestedRowExpanded(nestedrow),
                                last: j === nestedrow[_ctx.nestedRowsExpandKey].length - 1,
                                'bg-yellow-100': nestedrow_data.isYellow,
                            }]),
                        onClick: ($event: any) => (_ctx.onRowClick(nestedrow_data))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: `TableTd-${i}-${j}`,
                            class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                          }, [
                            (_ctx.$slots.td)
                              ? _renderSlot(_ctx.$slots, "td", {
                                  row: nestedrow_data,
                                  index: i,
                                  column: column,
                                  key: `${i}-${j}`
                                }, undefined, true)
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(nestedrow[column.key]), 1)
                                ], 64))
                          ], 2))
                        }), 128))
                      ], 10, _hoisted_37))
                    }), 128)),
                    (_ctx.$slots.overallNested)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: `TableOverallTd-${j}`,
                              class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                            }, [
                              _renderSlot(_ctx.$slots, "overallNested", {
                                column: column,
                                row: nestedrow
                              }, undefined, true)
                            ], 2))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.$slots.overall)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: `TableOverallTd-${j}`,
                    class: _normalizeClass(["tbody__td", { 'text-center': column.isCentered }])
                  }, [
                    _renderSlot(_ctx.$slots, "overall", { column: column }, undefined, true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 38)
  ], 64))
}